"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _FormHelperText = _interopRequireDefault(require("@mui/material/FormHelperText"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _mui = require("tss-react/mui");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var useStyles = (0, _mui.makeStyles)()(function (theme) {
  return {
    "default": {
      color: theme.palette.darkGrey.light
    },
    error: {
      color: theme.palette.red.main
    },
    success: {
      color: theme.palette.green.main
    }
  };
});
var FieldHelperText = function FieldHelperText(_ref) {
  var children = _ref.children,
    type = _ref.type,
    className = _ref.className;
  var _useStyles = useStyles(),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  return /*#__PURE__*/_react["default"].createElement(_FormHelperText["default"], {
    className: cx(classes[type], className)
  }, children);
};
FieldHelperText.propTypes = {
  type: _propTypes["default"].oneOf(['default', 'success', 'error']),
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string
};
FieldHelperText.defaultProps = {
  type: 'default',
  className: undefined
};
var _default = FieldHelperText;
exports["default"] = _default;